import React, { useEffect, useState } from "react";
import "../styles/Orders.css";
import logo from "../images/orders/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { orderIdData, purchaseRefData } from "../actions/usersActions";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import defaultFundIcon from "../images/Default icon.svg";
import { getLocalStorageUserId } from "../utils/userData";

const Orders = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [ordersData, setOrderData] = useState();
  const orderID = location.state?.orderId
    ? // const userId = getLocalStorageUserId()
      JSON.parse(location.state?.orderId ? location.state?.orderId : {})
    : {};

  console.log("location----", location);
  const getQueryParams = (queryString) => {
    const params = new URLSearchParams(queryString);
    console.log("paramsparams", params);
    const queryObject = {};
    for (let [key, value] of params.entries()) {
      queryObject[key] = value;
    }
    console.log("queryObject", queryObject);
    return queryObject;
  };
  const queryParams = getQueryParams(location.search);
  useEffect(() => {
    console.log("orderI111D", orderID);
    if (orderID?.lumpsum || orderID?.sip) {
      const ids = [];
      if (orderID?.lumpsum?.length > 0) {
        for (const lumpsum of orderID?.lumpsum) {
          ids?.push(lumpsum?.trxn_order_id);
        }
      }
      if (orderID?.sip?.length > 0) {
        for (const sip of orderID?.sip) {
          ids?.push(sip?.reg_id);
        }
      }
      console.log("location.state.user_id", location.state.user_id);
      dispatch(orderIdData(ids.join(","), location.state.user_id))
        .then((response) => {
          setOrderData(response);
          if (response?.status != true) {
            toast.error("Order is decaline, Please, try again");
          }
        })
        .catch((error) => toast.error("Order is decaline, Please, try again"));
    } else if (queryParams?.order) {
      console.log("queryParams?.order", queryParams?.order);
      dispatch(orderIdData(queryParams?.order))
        .then((response) => {
          setOrderData(response);
          if (response?.status != true) {
            toast.error("Order is decaline, Please, try again");
          }
        })
        .catch((error) => toast.error("Order is decaline, Please, try again"));
    }
  }, []);

  const [timeAgoData, setTimeAgoData] = useState({});

  // Function to calculate "time ago"
  const calculateTimeAgo = (startTime) => {
    const now = Date.now();
    const diffInSeconds = Math.floor((now - startTime) / 1000);

    if (diffInSeconds >= 0) {
      if (diffInSeconds < 60) {
        return `${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
      } else if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
      } else if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `${hours} hour${hours > 1 ? "s" : ""} ago`;
      } else {
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} day${days > 1 ? "s" : ""} ago`;
      }
    } else {
      return "Just now";
    }
  };

  useEffect(() => {
    const updatedTimeAgo = {};
    ordersData?.data?.forEach((response) => {
      const startTime = new Date(response?.createdAt).getTime(); // Use the timestamp field
      updatedTimeAgo[response?.unique_no] = calculateTimeAgo(startTime);
    });
    setTimeAgoData(updatedTimeAgo);
  }, [ordersData]);

  useEffect(() => {
    if (queryParams?.PaymentRefNo) {
      dispatch(purchaseRefData({ PaymentRefNo: queryParams?.PaymentRefNo }))
        .then((response) => {
          setOrderData(response);
          if (response?.status != true) {
            toast.error(
              "Order is decaline or order not found, Please, try again"
            );
          }
        })
        .catch((error) =>
          toast.error("Order is decaline or order not found, Please, try again")
        );
    }

    console.log("asasasas", location.state);
    // if (queryParams?.order) {
    //   const payload = {
    //     orderId: queryParams?.order,
    //     userId: location.state?.user_id,
    //   };
    //   dispatch(orderIdData(payload))
    //     .then((response) => {
    //       setOrderData(response);
    //       if (response?.status != true) {
    //         toast.error(
    //           "Order is decaline or order not found, Please, try again"
    //         );
    //       }
    //     })
    //     .catch((error) =>
    //       toast.error("Order is decaline or order not found, Please, try again")
    //     );
    // }
  }, []);
  // Parse the query parameters from the location.search
  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box ">
          <div
            style={{
              backgroundColor:
                queryParams?.PaymentStatus === "SUCCESS"
                  ? "green"
                  : queryParams?.PaymentStatus === "FAILURE"
                  ? "red"
                  : queryParams?.PaymentStatus === "PENDING"
                  ? "orange"
                  : "transparent",
              color:
                queryParams?.PaymentStatus === "SUCCESS"
                  ? "white"
                  : queryParams?.PaymentStatus === "FAILURE" ||
                    queryParams?.PaymentStatus === "PENDING"
                  ? "white"
                  : "black",
              paddingTop: "10px",
              paddingBottom: "0.08px",
              borderRadius: "5px",
              textAlign: "center",
            }}
          >
            <p>
              {queryParams?.PaymentStatus == "SUCCESS"
                ? "Order placed successfully!"
                : queryParams?.PaymentStatus == "FAILURE"
                ? "Order not placed, Please try again."
                : queryParams?.PaymentStatus == "PENDING"
                ? "Check after some time in transaction list"
                : ""}
            </p>
          </div>
          <h5 className="mb-4 main-heading-title mt-2">Orders</h5>

          {ordersData?.data?.length > 0 ? (
            ordersData?.data?.map((response) => {
              return (
                <div className="card mt-4 border-0 order_box">
                  <div className="d-flex column-gap-2  row-gap-2 flex-wrap align-items-center px-3 pt-3">
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          response?.master_scheme?.fund_icon?.icon
                            ? `${process.env.REACT_APP_FUND_ICON_URL}/logos/${response?.master_scheme?.fund_icon?.icon}.png`
                            : defaultFundIcon
                        }
                        alt="Fund Logo"
                        className="me-3 fund-logo"
                        width="50"
                      />

                      <Link to="/" className="">
                        <h5 className="mb-0 outerHeading">
                          {response?.scheme_name}
                        </h5>
                      </Link>
                    </div>
                    <div className="ms-sm-auto text-end currency2">
                      <h5 className="text_success mb-1 aditya_currency">
                        ₹ {response?.amt}
                      </h5>
                      <p className="mb-0  aditya_currency_time">
                        {timeAgoData[response?.unique_no] || "Just now"}
                      </p>
                     
                    </div>
                  </div>

                  <div className="d-flex gap-3 transaction_content2 pb-3  mt-2 px-3">
                    {/* <p className="mb-1  transaction_inner">
                      Transaction No.{" "}
                      <span className="d-block transaction_inner_value mt-1">
                        {response?.trxn_no}
                      </span>
                    </p> */}
                    <p className="mb-0 transaction_inner">
                      Ref.
                      <span className="d-block transaction_inner_value mt-1">
                        {response?.unique_no}
                      </span>
                    </p>

                     {(response?.trxn_type == "SI" || response?.trxn_type == "SO") && 
                     
                      <p className="mb-0 transaction_inner">
                      Transaction Type
                      <span className="d-block transaction_inner_value mt-1">
                      {response?.trxn_type == "SI" ? "Switch In" : "Switch Out"}
                      </span>
                    </p>
                  }
                  </div>
                </div>
              );
            })
          ) : (
            <p>Order not found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Orders;
